// extracted by mini-css-extract-plugin
module.exports = {"content":"PasswordReset_content__3yoWX","social":"PasswordReset_social__2Njaf","input":"PasswordReset_input__3DP4y","button":"PasswordReset_button__LhTN5"};